jQuery(document).ready(function($) {
    // Set triggers for each type of slider
    if ($('.homepage-images-slider').length) {
        $('.homepage-images-slider').slick({
            centerMode: true,
            centerPadding: '0px',
            variableWidth: true,
            infinite: true,
            arrows: true,
            prevArrow: $('.homepage-images-slider-prev'),
            nextArrow: $('.homepage-images-slider-next'),
            slidesToShow: 4,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                },
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
        });
    }
});